export default __webpack_public_path__ + "static/media/SDSG-logo.c059a13d.svg";